import React from "react";
import { Modal, Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { CheckoutSuccessContent } from "../index.styles";

export const CheckoutSuccessModal = ({
  visible,
  onClose,
  onViewOrders,
  onContinueBrowsing,
  salesNo,
}) => {
  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={400} centered destroyOnClose>
      <CheckoutSuccessContent>
        <CheckCircleFilled className="success-icon" />
        <h3>Order Placed Successfully</h3>
        <p>
          Your order {salesNo ? `(${salesNo}) ` : ""}has been placed. You can check its status in
          your Order History.
        </p>
        <div className="btn-container">
          <Button onClick={onContinueBrowsing}>Continue Browsing</Button>
          <Button
            className="order-btn"
            type="primary"
            style={{ background: "#1249bf", borderColor: "#1249bf" }}
            onClick={onViewOrders}
          >
            View Orders
          </Button>
        </div>
      </CheckoutSuccessContent>
    </Modal>
  );
};
